import React, { useState, useRef, useImperativeHandle } from "react";
import OneDayBox from "./CheckinOneDayBox";
import MultipleDayBox from "./CheckinMultipleDayBox";
import BatchDayBox from "./CheckinBatchDayBox";
import { Stack, Tabs, Tab, Button } from "@curves/ui-base";
import { refIsRequiredError } from "@util/utils";
import clsx from "clsx";

const ClockInTabs = props => {
	const { className, value: propsValue = "oneDay", handleTabsValue = () => {} } = props;
	const handleChange = (event, newValue) => {
		handleTabsValue && handleTabsValue(newValue);
	};
	return (
		<Stack className={className} justifyContent={"space-between"} alignItems={"end"}>
			<Tabs value={propsValue} onChange={handleChange} variant="scrollable" allowScrollButtonsMobile>
				{tabsContent.map(({ label, value }) => (
					<Tab key={label} label={label} value={value} />
				))}
			</Tabs>
		</Stack>
	);
};

const tabsContent = [
	{ label: "單日簽到", value: "oneDay", Component: OneDayBox },
	{ label: "多選簽到", value: "multipleDay", Component: MultipleDayBox },
	{ label: "批次簽到", value: "batchDay", Component: BatchDayBox },
];

const CheckinMultipleDateTimeBox = React.forwardRef(({ className, onSigninClick }, ref) => {
	const [tabValue, setTabValue] = useState("oneDay");
	const compRef = useRef(null);
	const Component = tabsContent.find(({ value }) => value === tabValue)["Component"];

	useImperativeHandle(
		ref,
		() => {
			return {
				getResult: () => compRef.current.getResult(),
				isError: () => refIsRequiredError(compRef),
			};
		},
		// eslint-disable-next-line
		[],
	);

	return (
		<Stack className={className} direction="column" spacing={2}>
			<ClockInTabs className="bg-light" value={tabValue} handleTabsValue={setTabValue} />
			<Stack spacing={2} justifyContent="start" alignItems="start">
				<Component ref={compRef} />
				<Button className={clsx("white-space-nowrap", { "mt-label": tabValue !== "multipleDay" })} variant="contained" color="info" onClick={onSigninClick}>
					簽到
				</Button>
			</Stack>
		</Stack>
	);
});

export default CheckinMultipleDateTimeBox;
